import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("未开始")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上传中")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("上传成功")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上传失败")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_font = _resolveComponent("hmd-font")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'READY')
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 0,
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'UPLOADING')
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 1,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'SUCCESS')
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 2,
          type: "success"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.status === 'FAIL')
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 3,
          type: "primary",
          danger: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}